import { Dialog } from '@headlessui/react';

interface PendingStockInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function PendingStockInfoModal({ isOpen, onClose }: PendingStockInfoModalProps) {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      className="relative z-[99999]"
    >
      <div className="fixed inset-0 bg-black/30 backdrop-blur-sm" aria-hidden="true" />

      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="w-full max-w-lg bg-white rounded-lg shadow-xl">
          <div className="p-6">
            <Dialog.Title className="text-xl font-bold mb-4 text-gray-900">
              Esta talla tiene un plazo de producción ampliado
            </Dialog.Title>

            <div className="space-y-4 text-gray-600 text-sm leading-relaxed">
              <p>
                Puedes comprarla por adelantado: estamos esperando la llegada de nuevas unidades a nuestro taller. Si la incluyes, el plazo de producción de <strong>todo el grupo</strong> será de un <strong>máximo de 45 días laborables desde la confirmación del pedido.</strong>
              </p>
              <p>
                Si prefieres mantener el plazo habitual de 30 días laborables, selecciona otra talla o color que no muestre este aviso.
              </p>
            </div>

            <div className="flex justify-end pt-6">
              <button
                type="button"
                onClick={onClose}
                className="px-6 py-2 bg-[#F90000] text-white text-sm font-medium hover:bg-[#D80000]"
              >
                Entendido
              </button>
            </div>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}
